export default __webpack_public_path__ + "static/media/meditations_icon.e610db99.svg";